<mat-dialog-content>
  <p>
    {{message}}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-raised-button class="yes-btn" (click)="onConfirmClick()" tabindex="0">{{confirmButtonText}}</button>
  @if (cancelButtonText !=='') {
    <button mat-raised-button mat-dialog-close tabindex="-1">{{cancelButtonText}}</button>
  }
</mat-dialog-actions>